import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SubGroupsLabels from './SubGroupsLabels';
import { setPositionIdentifier } from 'redux/profiles/ProfilesActions';

const mapDispatchToProps = dispatch => ({
  profileActions: bindActionCreators({ setPositionIdentifier }, dispatch)
});

export default connect(null, mapDispatchToProps)(SubGroupsLabels);



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/subGroupsMenu/c/subGroupsLabels/SubGroupsLabelsConnector.js